import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App'

declare global {
  interface Window {
    initialPath?: string;
  }
}

// Get the initial path from the window object (set during pre-rendering)
const initialPath = window.initialPath || '/'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: 'features',
        element: <App />,
      },
      {
        path: 'about',
        element: <App />,
      },
    ],
  },
], {
  // Use the initial path for the first render
  basename: initialPath === '/' ? undefined : initialPath,
})

export function Router() {
  return <RouterProvider router={router} />
} 